import React from 'react';

const DeleteProgressPopup = ({ progress, reportName }) => {
  // Determine overall status
  const isCompleted = progress?.complete === 'completed';
  const hasError = progress?.database === 'error' || progress?.powerbi === 'error';
  const isInProgress = !isCompleted && !hasError;

  // Calculate progress percentage
  const getProgressPercentage = () => {
    if (hasError) return 50; // Show partial progress on error
    if (progress?.complete === 'completed') return 100;
    if (progress?.powerbi === 'completed' || progress?.powerbi === 'in-progress') return 66;
    if (progress?.database === 'completed' || progress?.database === 'in-progress') return 33;
    return 0;
  };

  // Get status message
  const getStatusMessage = () => {
    if (hasError) return 'An error occurred during deletion';
    if (progress?.complete === 'completed') return 'Report deleted successfully!';
    if (progress?.powerbi === 'in-progress') return 'Deleting report...';
    if (progress?.database === 'in-progress') return 'Preparing deletion...';
    return 'Starting deletion...';
  };

  const progressPercentage = getProgressPercentage();
  const statusMessage = getStatusMessage();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.6)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 10001,
      animation: 'fadeIn 0.2s ease-in'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '12px',
        padding: '2.5rem',
        maxWidth: '450px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)'
      }}>
        {/* Header with Icon */}
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          {isInProgress && (
            <div className="loading" style={{ 
              margin: '0 auto 1rem auto',
              width: '40px',
              height: '40px',
              borderWidth: '4px'
            }}></div>
          )}
          {isCompleted && (
            <div style={{
              fontSize: '3rem',
              color: '#28a745',
              marginBottom: '1rem'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" style={{ display: 'block', margin: '0 auto' }}>
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
              </svg>
            </div>
          )}
          {hasError && (
            <div style={{
              fontSize: '3rem',
              color: '#dc3545',
              marginBottom: '1rem'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" viewBox="0 0 16 16" style={{ display: 'block', margin: '0 auto' }}>
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"/>
              </svg>
            </div>
          )}
          <h2 style={{ margin: '0', color: '#333', fontSize: '1.5rem' }}>
            {isCompleted ? 'Deletion Complete' : hasError ? 'Deletion Failed' : 'Deleting Report'}
          </h2>
        </div>

        {/* Report Name */}
        <div style={{
          background: '#f8f9fa',
          padding: '1rem',
          borderRadius: '8px',
          marginBottom: '1.5rem'
        }}>
          <p style={{ margin: '0', fontSize: '0.95rem', color: '#495057', textAlign: 'center' }}>
            <strong>{reportName || 'Unknown Report'}</strong>
          </p>
        </div>

        {/* Progress Bar */}
        <div style={{ marginBottom: '1rem' }}>
          <div style={{
            height: '8px',
            background: '#e9ecef',
            borderRadius: '4px',
            overflow: 'hidden'
          }}>
            <div style={{
              height: '100%',
              background: hasError ? '#dc3545' : isCompleted ? '#28a745' : '#007bff',
              width: `${progressPercentage}%`,
              transition: 'width 0.3s ease',
              borderRadius: '4px'
            }}></div>
          </div>
        </div>

        {/* Status Message */}
        <div style={{
          fontSize: '0.9rem',
          color: hasError ? '#dc3545' : '#6c757d',
          textAlign: 'center',
          fontStyle: 'italic'
        }}>
          {statusMessage}
        </div>
      </div>
    </div>
  );
};

export default DeleteProgressPopup;
